import { MetricCard, MetricStrip } from '@/components/ui'
import type { CofaStats } from '../api/types'

/** CofA KPIs for the page header band. Counted over lots in stock with the
 *  same status definitions as the table filter, so "Missing SPI" here and
 *  the Missing SPI filter's count agree. */
export function CofaKpiStrip({ stats, className }: { stats: CofaStats | undefined; className?: string }) {
  return (
    <MetricStrip variant="inline" className={className}>
      <MetricCard
        variant="inline"
        label="Lots in stock"
        value={(stats?.total_lots ?? 0).toLocaleString()}
        title={
          stats?.total_lots_all !== undefined
            ? `Tracked lots with quantity on hand. ${stats.total_lots_all.toLocaleString()} lots in total, including used-up ones.`
            : 'Tracked lots with quantity on hand.'
        }
      />
      <MetricCard
        variant="inline"
        label="Completion (in stock)"
        value={`${stats?.completion_pct ?? 0}%`}
        valueTone={(stats?.completion_pct ?? 0) < 80 ? 'warning' : 'default'}
        title="Lots in stock with every CofA they need: the vendor CofA, plus the SPI CofA for SPI products."
      />
      <MetricCard
        variant="inline"
        label="Missing SPI"
        value={(stats?.missing_spi ?? 0).toLocaleString()}
        valueTone={(stats?.missing_spi ?? 0) > 0 ? 'warning' : 'default'}
        title="SPI lots in stock that have the vendor CofA but no SPI CofA yet (ready to generate). Lots without a vendor CofA count as missing vendor."
      />
      <MetricCard
        variant="inline"
        label="Aging > 30d"
        value={(stats?.aging_over_30d ?? 0).toLocaleString()}
        valueTone={(stats?.aging_over_30d ?? 0) > 0 ? 'danger' : 'default'}
        title="Lots in stock, created more than 30 days ago, still missing a CofA they need."
      />
    </MetricStrip>
  )
}
